import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { __SetFilter } from '../../../../../actions/AsyncTable';
import { QUIZ_DISABLED } from '../../../../../constants/statuses';
import store from '../../../../../store';

const renderQuizDisabledField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    return (
        <NativeSelect {...input} {...custom}>
            {QUIZ_DISABLED.map((item, key) => (
                <option key={key} value={item.id}>
                    {i18n.t(item.title)}
                </option>
            ))}
        </NativeSelect>
    );
};

export default item => {
    const { i18n } = useTranslation();
    return (
        <Card>
            <CardContent>
                <Stack spacing={3} direction={'row'} alignItems={'center'}>
                    <Typography gutterBottom variant="h6" component="h2" style={{ marginBottom: 'unset' }}>
                        {i18n.t(item.label)}
                    </Typography>
                    <IconButton onClick={() => __SetFilter()(store.dispatch, store.getState)(item)}>
                        <DeleteIcon />
                    </IconButton>
                </Stack>
                <Field name={item.code} i18n={i18n} component={renderQuizDisabledField} type="text" />
            </CardContent>
        </Card>
    );
};
